import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Forward = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="forward icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7574 6.41421C9.97631 5.63317 9.97631 4.36684 10.7574 3.58579C11.5384 2.80474 12.8047 2.80474 13.5858 3.58579L22 12L13.5858 20.4142C12.8047 21.1953 11.5384 21.1953 10.7574 20.4142C9.97631 19.6332 9.97631 18.3668 10.7574 17.5858L14.3431 14L4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10L14.3431 10L10.7574 6.41421Z"
    />
  </svg>
)
